export const CATEGORY = 'CATEGORY'
export const TITLE = 'Title'
export const SAVE = 'SAVE'
export const DELETE_MESSAGE = 'Delete this?'
